module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/padova.691c6db9629a4cdd40378dc546e77f4e.jpg";